module.exports = __webpack_public_path__ + "static/img/gongzhonghao.1ce85de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gongzhonghao.png
// module id = tA3v
// module chunks = 1